import type { TRuleWithTheme } from '@/styles/theme';

export const icon: TRuleWithTheme = () => ({
    flexShrink: 0,
});
